import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import UserDisplayNameModel from './models/UserDisplayNameModel';
import UserApi from '../UserManagement/api/UserApi';
import { setUserDisplayNames, userSelectorSelector } from './reducers/UserSelectorReducer';

interface UserSelectorProps {
    selectedUserId: number | null,
    useAllUser?: boolean,
    label?: string,
    className?: string,
    onUserIdChange?: (value: number, displayName: string) => void,
}

const UserSelector: React.FunctionComponent<UserSelectorProps> = (props) => {
    const dispatch = useDispatch();
    const userSelectorData = useSelector(userSelectorSelector);

    useEffect(() => {
        if (userSelectorData.userDisplayNames.length === 0) {
            UserApi.GetDisplayNames()
                .then((response: BaseResponse<UserDisplayNameModel[]>) => {
                    if (response.success) {
                        dispatch(setUserDisplayNames(response.data))
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                }).catch((error) => {
                    Utility.Alert.Error(error);
                })
        }
    }, [])

    let getUserById = (id: number | null) => {
        if (!id) {
            return null;
        }
        return _.find(userSelectorData.userDisplayNames, (user) => {
            return user.id === id
        });
    }

    return (
        <>
            <Autocomplete
                className={props.className ? props.className : 'cargo-input-component'}
                options={userSelectorData.userDisplayNames}
                getOptionLabel={(option: UserDisplayNameModel) => {
                    return option.displayName;
                }}
                renderInput={(params) => <TextField {...params} label={props.label ? props.label : "Select User"} />}
                value={getUserById(props.selectedUserId)}
                onChange={(event: React.SyntheticEvent<Element, Event>, value: UserDisplayNameModel | null, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<UserDisplayNameModel> | undefined) => {
                    if (props.onUserIdChange) {
                        props.onUserIdChange(value ? value.id : -1, value ? value.displayName : "");
                    }
                }}
            />
        </>
    )
};

export default UserSelector;